import { ZfCard, ZfCardContent, ZfCardMedia, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import type { ImageKey } from '../../../styles/assets/imageMap';
import { imageMap } from '../../../styles/assets/imageMap';
import { useYwuApp } from '../../contexts/ywu-app-context';

interface IProps {
    title: string;
    description: string;
    imageKey: ImageKey;
    buttonLabelText: string;
    calculatorUrl: string;
}

export const CalculatorCard: FunctionComponent<IProps> = ({ title, description, imageKey, buttonLabelText, calculatorUrl }) => {
    const { activeLanguage: language } = useYwuApp();
    const urlWithLanguageQuery = `${calculatorUrl}?language=${language.toLowerCase()}`;

    const handleButtonClick = () => {
        window.open(urlWithLanguageQuery);
    };

    return (
        <ZfCard className="calculator-card">
            <ZfCardMedia className="calculator-card__image" image={`${imageMap[imageKey]}`}>
                <h4 className="calculator-card__title">{title}</h4>
            </ZfCardMedia>
            <ZfCardContent className="calculator-card__content">
                <label className="calculator-card__description">{description}</label>
                <div className="calculator-card__button-container">
                    <ZfTextButton onClick={handleButtonClick} hierarchy="secondary" size="medium">
                        {buttonLabelText}
                    </ZfTextButton>
                </div>
            </ZfCardContent>
        </ZfCard>
    );
};
